// !!!!
// This is a generated file.
// Do not manually change this file
// !!!!

export const Item_Kind = {
    Semifinished: 22413312,
    Finished_Product: 22413313,
    Purchase: 22413314,
};
